import { store, StoreInterface } from '@/store/store'
import { createContext } from 'react'

// export const StoreContext = createContext({
//   ui: uiStore
// } as StoreContext)

export const StoreContext = createContext<StoreInterface>(store)
